import * as api from '../../api/retention';
import { asyncAction } from '../common';
import { errorHandlerUnitsQueries } from './dashboards';

export const executeDashboardRetentionSimple = (unit, executeId) =>
  asyncAction(
    'EXECUTE_DASHBOARD_RETENTION_SIMPLE_QUERY',
    api.executeDashboardRetentionQuery(unit, executeId),
    errorHandlerUnitsQueries(unit.id)
  );

export const changeFirstEvent = (unitId, event) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_FIRST_EVENT',
  unitId,
  event,
});

export const changeReturnEvent = (unitId, event) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_RETURN_EVENT',
  unitId,
  event,
});

export const changeDimensionType = (unitId, dimensionType) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_DIMENSION_TYPE',
  unitId,
  dimensionType,
});

export const changeRetentionView = (unitId, view) => ({
  type: 'DASHBOARD_CHANGE_RETENTION_VIEW',
  unitId,
  view,
});

export const toggleRetentionTrendLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_TREND_LINE',
  unitId,
});

export const toggleRetentionAverageLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_AVERAGE_LINE',
  unitId,
});

export const toggleRetentionMedianLine = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_MEDIAN_LINE',
  unitId,
});

export const toggleRetentionAdaptive = (unitId) => ({
  type: 'DASHBOARD_TOGGLE_RETENTION_ADAPTIVE',
  unitId,
});
